import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { FarmAddressesCard } from './FarmAddressesCard';
import { Snapshots } from './Snapshots';
import { FarmParameters } from './FarmParameters';
import { Spinner } from 'react-bootstrap';
import { RewardDistributionDataCard } from './RewardDistributionDataCard';
import { ContractInfoCard } from './ContractInfoCard';
import { FullRewardDistribution } from './FullRewardDistribution';

export const RawVestaMinter = () => {
  const rawVestaConfig = useSelector(
    (state: RootState) => state.rawVesta.config
  );
  const [selectedAddress, setSelectedAddress] = useState<string>();

  return rawVestaConfig.status !== 'succeeded' ? (
    <div className='spinner-pos'>
      <Spinner animation={'border'} />
    </div>
  ) : (
    <div className='container-fluid mt-3'>
      <div className='row'>
        <div className='col-12 mb-2'>
          <FullRewardDistribution />
        </div>
        <div className='col-12 col-lg-9'>
          <FarmAddressesCard onSelectAddress={setSelectedAddress} />
        </div>
        <div className='col-12 col-lg-3'>
          <ContractInfoCard />
        </div>
        <div className='col-12 col-lg-4 mt-2'>
          <FarmParameters address={selectedAddress} />
          <div className='mt-2'>
            <RewardDistributionDataCard selectedAddress={selectedAddress} />
          </div>
        </div>
        <div className='col-12 col-lg-8 mt-2'>
          <Snapshots address={selectedAddress} />
        </div>
      </div>
    </div>
  );
};
